
import React,{ useState } from 'react';
import AppHelper from '../helpers/App';


const ImageWithLoading = ({ src,srcSet,sizes,alt }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div>
          {!loaded ? (
            <img src="https://acerecords.co.uk/layout/img/placeholders/ph.gif" width="100%" alt={alt}></img>  
          ) : null}
          <img
            src={src}
            sizes={sizes}
            srcSet={srcSet}
            alt={alt}
            style={!loaded ? { display: 'none' } : {}}
            onLoad={() => setLoaded(true)}
            onError={()=> setLoaded(false)}
            />
        </div>
      );
}


const ListItem = ({ json }) => {
    const {
        id,
        t: title,
        f: format,
        pid: prodid,
        rp: retailPrice,
        rd: releasedate,
        gn: genreName,
        an: artistName,
        u: url,
        i: image,
        cnt: continent_tag,
        cot: country_tag,
        ft: format_tag,
        gt: genre_tag,
        lt: label_tag,
        pt: people_tag,
        st: state_tag,
        tt: theme_tag
    } = json;

    

    // const genderTag = AppHelper.getFirstTag(genre_tag, '');
    //<img src={imageSrc} srcSet={imageSrcSet}  />
    const { imageSrc, imageSrcSet } = AppHelper.getImageData(image);

    return (
        <li>
            <a href={"https://acerecords.co.uk/" + url}>
                <ImageWithLoading src={imageSrc} srcSet={imageSrcSet} sizes="(min-width: 1024px) 20vw, (min-width: 750px) 33vw, 50vw" alt={title} />
                <h3>{title}</h3>
                <p>{genreName}</p>
                <p className="artist">{artistName}</p>
                <p>{format} &pound;{retailPrice.toFixed(2)}</p>
            </a>
        </li>
    );
}





export default ListItem;